export default function IconQuote() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 50 38.709"
    >
      <path
        d="M28.709 0H50v18.549c0 13.387-5.968 19.838-21.291 20.16v-10c6.936-.322 9.678-2.419 9.839-9.193h-9.839V0ZM0 0h21.129v18.549c0 13.387-5.968 19.838-21.129 20.16v-10c6.774-.322 9.677-2.419 9.677-9.193H0V0Z"
        data-name="Layer 1"
        style={{
          fill: "var(--color-primary)",
          strokeWidth: 0,
        }}
      />
    </svg>
  );
}
